import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize() {
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('preventBackNavigation');
    } else {
      throw new Error('Flutter InAppWebView is not available');
    }
  }
}
